import { Route, Outlet } from 'react-router-dom';
import { type RouteRegistryEntry } from 'FrontRoyalRouteRegistry/FrontRoyalRouteRegistry.types';
import { ProtectedRoute } from 'ProtectedRoute';
import { routeAllowedIfStreamAvailableOffline } from 'OfflineMode';
import { ShowStreamComponent } from './components/ShowStreamComponent';
import { ShowStandaloneLessonComponent } from './components/ShowStandaloneLessonComponent';
import { ShowPracticePlayerComponent } from './components/ShowPracticePlayerComponent';
import { LESSON_PLAYER_ROUTES } from './routes';

// Re-export routes for backwards compatibility
export { LESSON_PLAYER_ROUTES } from './routes';

export function configureLessonPlayerRoutes(): RouteRegistryEntry[] {
    return [
        {
            routes: LESSON_PLAYER_ROUTES,
            config: {
                headerLayout: 'lesson-player',
            },
        },
    ];
}

export function getLessonPlayerRoutes() {
    return (
        <Route id="lesson-player-routes" element={<Outlet />}>
            {/* ShowStream routes */}
            <Route
                path={LESSON_PLAYER_ROUTES.COURSE_STREAM_SHOW.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted" allowedOffline={routeAllowedIfStreamAvailableOffline}>
                        <ShowStreamComponent />
                    </ProtectedRoute>
                }
            />
            <Route
                path={LESSON_PLAYER_ROUTES.STREAM_SHOW.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted" allowedOffline={routeAllowedIfStreamAvailableOffline}>
                        <ShowStreamComponent />
                    </ProtectedRoute>
                }
            />

            {/* ShowStandaloneLesson routes */}
            <Route
                path={LESSON_PLAYER_ROUTES.LESSON_TITLE_SHOW.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted">
                        <ShowStandaloneLessonComponent />
                    </ProtectedRoute>
                }
            />
            <Route
                path={LESSON_PLAYER_ROUTES.LESSON_TITLE.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted">
                        <ShowStandaloneLessonComponent />
                    </ProtectedRoute>
                }
            />
            <Route
                path={LESSON_PLAYER_ROUTES.LESSON_MODE_TITLE.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted">
                        <ShowStandaloneLessonComponent />
                    </ProtectedRoute>
                }
            />
            <Route
                path={LESSON_PLAYER_ROUTES.LESSON_ID.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted">
                        <ShowStandaloneLessonComponent />
                    </ProtectedRoute>
                }
            />

            {/* ShowPracticePlayer route */}
            <Route
                path={LESSON_PLAYER_ROUTES.PRACTICE_SHOW.path}
                element={
                    <ProtectedRoute accessPolicy="unrestricted">
                        <ShowPracticePlayerComponent />
                    </ProtectedRoute>
                }
            />
        </Route>
    );
}
